export { default } from './RewardsBox.vue';